import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider, useConfig } from "./contexts/ConfigContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ChatModeProvider } from "./contexts/ChatModeContext";
import { Header } from "./components/Header";
import { LoginPage } from "./components/LoginPage";
import { ChatLayout } from "./components/ChatLayout";
import { Spinner } from "@fluentui/react-components";
import "./styles/global.css";

function AppShell() {
  const { isLoading: configLoading, errors: configErrors } = useConfig();
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // Config loading
  if (configLoading) {
    return (
      <div className="app-loading">
        <Spinner size="large" label="Loading..." />
      </div>
    );
  }

  // Config errors
  if (configErrors.length > 0) {
    return (
      <div className="config-error">
        <h2>Configuration Required</h2>
        <p>Please configure the following settings:</p>
        <ul>
          {configErrors.map((e, i) => (
            <li key={i}>{e}</li>
          ))}
        </ul>
        <p>
          Update the values in <code>public/config.json</code> or create a{" "}
          <code>.env</code> file with the required variables.
        </p>
        <p>
          See <code>README.md</code> for setup instructions.
        </p>
      </div>
    );
  }

  // Auth loading
  if (authLoading) {
    return (
      <div className="app-loading">
        <Spinner size="large" label="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <ChatModeProvider>
      <div className="app-shell">
        <Header />
        <ChatLayout />
      </div>
    </ChatModeProvider>
  );
}

export function App() {
  return (
    <FluentProvider theme={webLightTheme}>
      <ConfigProvider>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </ConfigProvider>
    </FluentProvider>
  );
}
